import { NavigationLayoutList } from "#models/navigation";

export function getNavigationList(showFileManagerFn: () => void): NavigationLayoutList {
    return [
        {
            text: "i18n.navigation.promos.title",
            title: "i18n.navigation.promos.title",
            icon: "stock",
            defaultOpened: true,
            submenu: true,
            children: [
                {
                    text: "i18n.navigation.promos.list",
                    link: "/promos",
                    matcher: "promos",
                    withCurrentQuery: true,
                    queryParams: { page: 1, "filters[type_id]": null },
                },
                {
                    text: "i18n.navigation.promos.normal",
                    link: "/promos",
                    matcher: "promos",
                    withCurrentQuery: true,
                    queryParams: { page: 1, "filters[type_id]": "PromoDiscount" },
                },
                {
                    text: "i18n.navigation.promos.credit",
                    link: "/promos",
                    matcher: "promos",
                    withCurrentQuery: true,
                    queryParams: { page: 1, "filters[type_id]": "PromoCredit" },
                },
                {
                    text: "i18n.navigation.promos.gift",
                    link: "/promos",
                    matcher: "promos",
                    withCurrentQuery: true,
                    queryParams: { page: 1, "filters[type_id]": "PromoGift" },
                },
                {
                    text: "i18n.navigation.promos.combo",
                    link: "/promos",
                    matcher: "promos",
                    withCurrentQuery: true,
                    queryParams: { page: 1, "filters[type_id]": "PromoCombo" },
                },
            ],
        },
        { text: "i18n.navigation.promo_codes", icon: "gift", link: "/promo-codes" },
        {
            icon: "lock",
            title: "i18n.navigation.administration",
            text: "i18n.navigation.administration",
            submenu: true,
            defaultOpened: false,
            children: [
                {
                    link: "/cli-commands",
                    text: "i18n.navigation.cli_commands",
                },
                { text: "i18n.navigation.config", link: "/config" },
                { text: "i18n.navigation.promo_priorities", link: "/promo-priorities" },
            ],
        },
        {
            text: "i18n.file_manager.button",
            icon: "cloud",
            link: "/file-manager",
            callback: showFileManagerFn,
        },
    ];
}
